import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { PrimaryButton } from 'ui/button';
import { WarningFill16 } from 'ui/icons';
import { colors, spacing, zIndex } from 'ui/theme';
import { linksFormId } from '../constants';

const StyledFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${zIndex.drawer};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing.base};
  padding: ${spacing.base} ${spacing.layoutLRPadding};
  background-color: ${colors.backgroundPrimary};
  border-top: ${spacing.single} solid ${colors.borderPrimary};
`;

export const FOOTER_TEXT = {
  bannerText: 'Unsaved changes',
  buttonText: 'Save changes',
};

const { bannerText, buttonText } = FOOTER_TEXT;

export const Footer = () => {
  const {
    formState: { isDirty },
  } = useFormContext();

  return (
    <StyledFooter>
      {isDirty && (
        <Banner Icon={<WarningFill16 />} variant={BannerVariants.WARNING} isSubtle>
          {bannerText}
        </Banner>
      )}
      <PrimaryButton
        data-test="link-expiration-save-button"
        form={linksFormId}
        isDisabled={!isDirty}
        type="submit"
      >
        {buttonText}
      </PrimaryButton>
    </StyledFooter>
  );
};
